import React from 'react';
import renderHTML from 'react-render-html';
import TextWithTooltip from '../../../../components/text-with-tooltip';
import { Desktop, Mobile } from '../../../../app-responsive';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';
import { MIGRATE_TO_ENTERPRISE_TRUNK, REQUEST_CALL_BACK } from '../../../../app-constants';
import SSMRadioButton from '../ssm-radio-button/ssm-radio-button';
import FormSelectField from '../../../../components/form/select-field';
import FormError from '../../../../components/form/error/error';
import './isdn-inDial-sip-connect-service-details.css';

const IsdnInDialSipConnectServiceDetalis = (props) => {
  const {
    siteId,
    authorableContent,
    inDialServicesDetailsSitedata,
    migrateToEnterpriseTrunk,
    enterpriseTrunking,
    enterpriseTrunkingNumbersOption,
    enterpriseTrunkingNumbers,
    handleMigrateToEnterpriseTrunk,
    handlEnterpriseTrunkSelection,
    migrateToEnterpriseTrunkSelection,
    enterpriseTrunkValidationTracking,
    formSubmitted,
  } = props;

  const {
    title,
    currentServicesText,
    migrateToSipConnectText,
    confirmOrderText,
    inDialText,
    typeTooltip,
    typeLabel,
    serviceNumberTooltip,
    serviceNumberLabel,
    numberRangesTooltip,
    numberRangesLabel,
    numberOfTrunksTooltip,
    numberOfTrunksLabel,
    actionTooltip,
    actionLabel,
    migratetoAllEnterprise,
    migratetoAllSIP,
    selectEnterpriseTrunking,
    migratetoEnterpriseErrorText,
  } = authorableContent;

  const
    {
      enterpriseTrunkingPreText,
      enterpriseTrunkingPostText,
    } = props.sipConnectServiceTermAuthorableContent;

  const serviceDetailsTableDesktop = inDialServicesDetailsSitedata.map(item => (
    <div className="row" key={item.serviceNumber}>
      <div className="col-1 in-dial-label">
        <span>{inDialText}</span>
      </div>
      <div className="col-2">
        <span>{item.serviceNumber}</span>
      </div>
      <div className="col-3">
        {item.numberRanges.map((range, index) => (item.numberRanges.length === index + 1 ? (<span key={`range ${range}`}>{range}</span>)
          : (<span key={`range ${range}`}>{range}<br /></span>)))}
      </div>
      <div className="col-2">
        <span>{item.numberOfTrunks}</span>
      </div>
      <div className="col-4">
        {(enterpriseTrunking && migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`]) ?
          <React.Fragment>
            <FormSelectField
              id={`${siteId}-${item.serviceNumber}`}
              label=""
              options={enterpriseTrunkingNumbersOption}
              onBlur={handlEnterpriseTrunkSelection}
              value={(migrateToEnterpriseTrunkSelection[`${siteId}-${item.serviceNumber}`] === 'REQUEST_CALL_BACK') ?
                REQUEST_CALL_BACK : migrateToEnterpriseTrunkSelection[`${siteId}-${item.serviceNumber}`]}
              sendKeyValueOnChange
              placeholder={selectEnterpriseTrunking}
            />
            {(enterpriseTrunkValidationTracking && formSubmitted && !migrateToEnterpriseTrunkSelection[`${siteId}-${item.serviceNumber}`]) &&
              <FormError errorText={migratetoEnterpriseErrorText} />
            }
          </React.Fragment>
          :
          <span>{migrateToSipConnectText}</span>
        }
      </div>
    </div>
  ));

  const serviceDetailsTableMobile = inDialServicesDetailsSitedata.map(item => (
    <div className="row" key={item.serviceNumber}>
      <div className="col-6 in-dial-label">
        <TextWithTooltip
          labelText={typeLabel}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          id="isdn-in-dial-table-type-tooltip"
          toolTipText={typeTooltip}
        />
        <span>{inDialText}</span>
      </div>
      <div className="col-6">
        <TextWithTooltip
          labelText={serviceNumberLabel}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          id="isdn-in-dial-table-service-tooltip"
          toolTipText={serviceNumberTooltip}
        />
        <span>{item.serviceNumber}</span>
      </div>
      <div className="col-6">
        <TextWithTooltip
          labelText={numberRangesLabel}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          id="isdn-in-dial-table-number-tooltip"
          toolTipText={numberRangesTooltip}
        />
        {item.numberRanges.map((range, index) => (item.numberRanges.length === index + 1 ? (<span key={`range ${range}`}>{range}</span>)
          : (<span key={`range ${range}`}>{range}<br /></span>)))}
      </div>
      <div className="col-6">
        <TextWithTooltip
          labelText={numberOfTrunksLabel}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          id="isdn-in-dial-table-trunks-tooltip"
          toolTipText={numberOfTrunksTooltip}
        />
        <span>{item.numberOfTrunks}</span>
      </div>
      <div className="col-12">
        <TextWithTooltip
          labelText={actionLabel}
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          id="isdn-in-dial-table-action-tooltip"
          toolTipText={actionTooltip}
        />
        {enterpriseTrunking &&
          <div className="row option-section">
            <div className="col-6">
              <SSMRadioButton
                radioButtonId={`${siteId}-migrateToSip`}
                radioButtonLabel={migratetoAllSIP}
                radioButtonChecked={!(migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`])}
                onRadioButtonCallBackActionWithToggle={handleMigrateToEnterpriseTrunk}
              />
            </div>
            <div className="col-6">
              <SSMRadioButton
                radioButtonId={`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`}
                radioButtonLabel={migratetoAllEnterprise}
                radioButtonChecked={(migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`])}
                onRadioButtonCallBackActionWithToggle={handleMigrateToEnterpriseTrunk}
              />
            </div>
          </div>
        }
        {(enterpriseTrunking && migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`]) ?
          <React.Fragment>
            <FormSelectField
              id={`${siteId}-${item.serviceNumber}`}
              label=""
              options={enterpriseTrunkingNumbersOption}
              onBlur={handlEnterpriseTrunkSelection}
              value={(migrateToEnterpriseTrunkSelection[`${siteId}-${item.serviceNumber}`] === 'REQUEST_CALL_BACK') ?
                REQUEST_CALL_BACK : migrateToEnterpriseTrunkSelection[`${siteId}-${item.serviceNumber}`]}
              sendKeyValueOnChange
              placeholder={selectEnterpriseTrunking}
            />
            {(enterpriseTrunkValidationTracking && formSubmitted && !migrateToEnterpriseTrunkSelection[`${siteId}-${item.serviceNumber}`]) &&
              <FormError errorText={migratetoEnterpriseErrorText} />
            }
          </React.Fragment>
          :
          <span>{migrateToSipConnectText}</span>
        }
      </div>
    </div>
  ));

  return (
    <div className="isdn-in-dial-sip-connect-service-details">
      <div className="row">
        <div className="col-12 pl-sm-0">
          <h2 className="heading">{title}</h2>
        </div>
      </div>
      {enterpriseTrunking && (
        <div className="row enterprise-trunk-text">
          <div className="col-12 pl-sm-0">
            {renderHTML(stripStartingAndEndingPTags(enterpriseTrunkingPreText))}
            {enterpriseTrunkingNumbers.filter(numbers => numbers !== 'REQUEST_CALL_BACK').join(',')}
            {renderHTML(stripStartingAndEndingPTags(enterpriseTrunkingPostText))}
          </div>
        </div>
      )}

      <div className="isdn-in-dial-sip-connect-service-table">
        <Desktop>
          <div className="row">
            <div className="col-8">
              <h2 className="heading">{currentServicesText}</h2>
            </div>
            <div className="col-4">
              <h2 className="heading">{confirmOrderText}</h2>
            </div>
          </div>
          <div className="row table-labels">
            <div className="col-1">
              <TextWithTooltip
                labelText={typeLabel}
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="isdn-in-dial-table-type-tooltip"
                toolTipText={typeTooltip}
              />
            </div>
            <div className="col-2">
              <TextWithTooltip
                labelText={serviceNumberLabel}
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="isdn-in-dial-table-service-tooltip"
                toolTipText={serviceNumberTooltip}
              />
            </div>
            <div className="col-3">
              <TextWithTooltip
                labelText={numberRangesLabel}
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="isdn-in-dial-table-number-tooltip"
                toolTipText={numberRangesTooltip}
              />
            </div>
            <div className="col-2">
              <TextWithTooltip
                labelText={numberOfTrunksLabel}
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="isdn-in-dial-table-trunk-tooltip"
                toolTipText={numberOfTrunksTooltip}
              />
            </div>
            <div className="col-4">
              <TextWithTooltip
                labelText={actionLabel}
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="isdn-in-dial-table-action-tooltip"
                toolTipText={actionTooltip}
              />
              {enterpriseTrunking &&
                <React.Fragment>
                  <SSMRadioButton
                    radioButtonId={`${siteId}-migrateToSip`}
                    radioButtonLabel={migratetoAllSIP}
                    radioButtonChecked={!(migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`])}
                    onRadioButtonCallBackActionWithToggle={handleMigrateToEnterpriseTrunk}
                  />
                  <SSMRadioButton
                    radioButtonId={`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`}
                    radioButtonLabel={migratetoAllEnterprise}
                    radioButtonChecked={(migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`])}
                    onRadioButtonCallBackActionWithToggle={handleMigrateToEnterpriseTrunk}
                  />
                </React.Fragment>
              }
            </div>
          </div>
          {serviceDetailsTableDesktop}
        </Desktop>
        <Mobile>
          {serviceDetailsTableMobile}
        </Mobile>
      </div>
    </div>
  );
};
export default IsdnInDialSipConnectServiceDetalis;
